import styles from './style.module.scss';
import HoverCollapsibleSection from 'components/collapsible';
import { Add, Remove } from '@mui/icons-material';
import { ExpCommercialConfig } from 'tenants';
import HtmlTrans from 'components/html-trans';
import { useTranslation } from 'next-i18next';
import CtaButtons from '../cta-buttons';

const faqCollapsedIcon = () => {
  return (
    <div className={styles['toggle-icon']}>
      <Add />
    </div>
  );
};

const faqExpandedIcon = () => {
  return (
    <div className={styles['toggle-icon']}>
      <Remove />
    </div>
  );
};

export type FaqData = NonNullable<ExpCommercialConfig['faq']>;

export interface CommercialFaqProps {
  faqData: FaqData;
  disableHoverExpansion?: boolean;
  showNumbers?: boolean;
}

function CommercialFaq({ 
  faqData, 
  disableHoverExpansion = true,
  showNumbers = true,
}: CommercialFaqProps) {
  const { t } = useTranslation();
  
  if (!faqData.content || faqData.content.length === 0) {
    return null;
  }

  const content = faqData.content.map(item => ({
    title: t(item.title),
    children: <HtmlTrans
      t={t}
      i18nKey={item.children}
      styleOverrides={item.styleOverrides}
      values={item.values}
    />,
  }));

  return (
    <div className={styles.component} id='commercial-exp-faq'>
      <h2>{t(faqData.title)}</h2>
      <HoverCollapsibleSection 
        items={content}
        isHoverable={!disableHoverExpansion}
        disableGutters
        showNumbers={showNumbers}
        className={styles['faq-content']}
        headerClassName={styles['faq-header']}
        detailsClassName={styles['faq-details']}
        iconOverride={{
          expandedIcon: faqExpandedIcon(),
          collapsedIcon: faqCollapsedIcon(),
        }}
      />
      <CtaButtons containerClassName={styles['faq-cta-buttons']} />
    </div>
  );
}

export default CommercialFaq; 